import { ISlots, IMonthItem, ICurrentDates, IFormData } from "@/types/agenda.type";
import { getFutureYears } from "@/utils/get-future-years";

export const years: number[] = getFutureYears(10);
export const months: IMonthItem[] = [
  { id: "1", value: "01", name: "Jan" },
  { id: "2", value: "02", name: "Feb" },
  { id: "3", value: "03", name: "Mar" },
  { id: "4", value: "04", name: "Apr" },
  { id: "5", value: "05", name: "May" },
  { id: "6", value: "06", name: "Jun" },
  { id: "7", value: "07", name: "Jul" },
  { id: "8", value: "08", name: "Aug" },
  { id: "9", value: "09", name: "Sep" },
  { id: "10", value: "10", name: "Oct" },
  { id: "11", value: "11", name: "Nov" },
  { id: "12", value: "12", name: "Dec" },
];

export const initialCurrentDates: ICurrentDates = {
    monday: '',
    tuesday: '',
    wednesday: '',
    thursday: '',
    friday: '',
    saturday: '',
    sunday: ''
}

export const initialSlots: ISlots = {
  monday: [],
  tuesday: [],
  wednesday: [],
  thursday: [],
  friday: [],
  saturday: [],
  sunday: [],
};
  
export const initialFormData: IFormData = {
    first_name: "",
    last_name: "",
    email: "",
    matricule_code: "",
    gender: "",
    message: "",
    dob: "",
    gsm_phone_number: "",
};

export const slotObj: ISlots = {
    monday: [],
    tuesday: [],
    wednesday: [],
    thursday: [],
    friday: [],
    saturday: [],
    sunday: [],
};